export interface MagentoCustomAttribute {
  attribute_code: string;
  value: string;
}
